import React from 'react';
import { ProjectProgressHeader } from './ProjectProgressHeader';
import { ProjectProgressKpiCards } from './ProjectProgressKpiCards';
import { ProjectProgressGantt } from './ProjectProgressGantt';
import { ProjectProgressSidebar } from './ProjectProgressSidebar';
import { useProjectProgress } from '../hooks/useProjectProgress';

export function ProjectProgressMain() {
  const { data, isLoading } = useProjectProgress();

  if (isLoading) {
    return <div className="p-10 text-center text-slate-400">Đang tải dữ liệu tiến độ...</div>;
  }

  return (
    <div className="space-y-6">
      {/* Header Điều khiển */}
      <ProjectProgressHeader />

      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
        {/* Nội dung chính */}
        <div className="xl:col-span-9 space-y-6">
          <ProjectProgressKpiCards data={data} />
          <ProjectProgressGantt data={data} />
        </div>

        {/* Sidebar */}
        <div className="xl:col-span-3 space-y-6">
          <ProjectProgressSidebar data={data} />
        </div>
      </div>
    </div>
  );
}
